module.exports = __webpack_public_path__ + "img/1x.74c4f49.jpg";